export default __webpack_public_path__ + "static/media/katiemccabe-mob.c95c7640.mp4";